import { Vue, Component, Prop, Ref } from 'vue-property-decorator'

@Component({
    name: 'DeleteWarning'
})
export class DeleteWarningImpl extends Vue {
    @Prop({
        type: Boolean
    }) visible: boolean

    @Prop({
        type: String
    }) title: string

    @Prop({
        type: String
    }) text: string

    @Prop({
        type: Boolean,
        default: false,
    }) useAnimationIcon: boolean

    onUpdateVisible() {
        this.$emit('update:visible')
    }

    onCancel() {
        this.$emit('cancel')
    }
    onConfirm() {
        this.$emit('confirm')
    }
}
